import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewDiscount = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=discount&`, data);
  return res.data;
};
export const getAllDiscounts = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/common?table=discount&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getDiscountById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/common?table=discount&id=${id}`);
  return res.data;
};
export const updateDiscountById = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=discount&id=${id}`,
    data
  );
  return res.data;
};
export const getVerifiedData = async (data, isVoucher) => {
  const res = await axios.get(
    `${API_BASE_URL}/discount/coupon_validation?coupon_code=${data}&isVoucher=${isVoucher}`
  );
  return res.data;
};
